<app-breadcrumb [master]="'Marketing'" [parentName]="'Wyniki konkursów'" [name]="'Szczegóły'"></app-breadcrumb>
<mat-tab-group (selectedTabChange)="onTabChange($event)">
  <mat-tab label="Dane">
    <app-competition-import-row-details-view *ngIf="!modify" [competitionParticipant]="competitionParticipant" (modifyClicked)="modify = true"></app-competition-import-row-details-view>
    <app-edit-competition-import-row *ngIf="modify" [importRow]="competitionImportRow" (closeModification)="modify = false; loadImportRow()"></app-edit-competition-import-row>
  </mat-tab>

  <mat-tab label="Dokumenty">
    <ng-template matTabContent>
      <button [disabled]="!(userPermissions | async).document.write" mat-stroked-button color="primary" class="add-button" (click)="addDocument()"><mat-icon>add</mat-icon> Dodaj dokument</button>

      <app-document-list [excludeColumns]="['deviceProtocolDate']" [documents]="documents" (changed)="loadDocuments()"></app-document-list>
    </ng-template>
  </mat-tab>

  <mat-tab label="Historia zmian">
    <ng-template matTabContent>
      <app-log-list [competitionImportRow]="competitionImportRow"></app-log-list>
    </ng-template>
  </mat-tab>
</mat-tab-group>
